import MTable from "../../../components/mtable"
import { date } from "../../../utils/date"
import CollapsingSection from "../../../components/CollapsingSection"

export default function DirectInvitations({programId}) {

    const mapper = {columns: [
        {
            label: "Email",
            value: (item) => item.email
        },
        {
            label: "Role",
            value: (item) => item.type
        },
        {
            label: "Created At",
            value: (item) => date(item.createdAt)
        },
        {
            label: "Status",
            value: (item) => item.status
        }
    ]}

    return(
        <CollapsingSection title="Direct Invitations">
            <MTable path={`programs/${programId}/invitations`} mapper={mapper} />
        </CollapsingSection>
    )
}